import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class CustomFileHandlerService {

  unsupportedExtensionsCTMap: Map<string, string>;

  constructor() {
    this.initUnsupportedExts();
  }


  async manipulateFiles(files: FileList): Promise<FileList> {
    try {
      const dataTransfer = new DataTransfer();
      const newFilesList = await this.getManipulatedCTFiles(files);
      newFilesList.forEach(newFile => dataTransfer.items.add(newFile));
      return dataTransfer.files;
    } catch (error) {
      throw new Error(error);
    }
  }

  async getManipulatedCTFiles(files) {
    const filesArr = [];
    try {
      for (const originalFile of files) {
        const fileExt = /(?:\.([^.]+))?$/.exec(originalFile.name)[1];
        if (this.unsupportedExtensionsCTMap.has(fileExt)) {
          const fileArrBuff = await originalFile.arrayBuffer();
          const newFile = new File([fileArrBuff], originalFile.name,
            { type: this.unsupportedExtensionsCTMap.get(fileExt) }
          );
          filesArr.push(newFile);
        } else {
          filesArr.push(originalFile);
        }
      }
      return filesArr;
    } catch (error) {
      throw new Error(error);
    }
  }


  initUnsupportedExts() {
    this.unsupportedExtensionsCTMap = new Map<string, string>();
    /*
      Add the extenstion and it's corresponding content type for
      file objects whose content type in native JS file object is empty string (for unkown types as per MDN).
      For eg: for files with .msg the file.type value is empty string.
    */
    this.unsupportedExtensionsCTMap.set('msg', 'application/vnd.ms-outlook');
    this.unsupportedExtensionsCTMap.set('xls', 'application/xls');
  }

}
